(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["institutional-faq-item"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.currentScript?.closest('.shopify-block') || document;
    const detailsList = root.querySelectorAll('[data-faq-item]');

    detailsList.forEach((details) => {
      const summary = details.querySelector('summary');
      const answer = details.querySelector('.institutional-faq-block__answer');
      if (!summary || !answer || details.dataset.faqReady === 'true') return;

      details.dataset.faqReady = 'true';

      const updateHeight = () => {
        details.style.setProperty('--faq-answer-height', `${answer.scrollHeight}px`);
      };

      updateHeight();
      window.addEventListener('resize', updateHeight);

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (details.dataset.faqAnimating === 'true') return;

        updateHeight();
        details.dataset.faqAnimating = 'true';
        details.classList.toggle('is-open');

        window.setTimeout(() => {
          details.dataset.faqAnimating = 'false';
        }, 340);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
